import { useEffect, useRef, useState } from "react";

// Measure the container once, then track resize via ResizeObserver. Charts
// don't need sub-pixel precision, so we round to integers to avoid churny
// re-renders that happen when parent elements oscillate during layout.
export const useResize = (minWidth = 240, minHeight = 120) => {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: minWidth, height: minHeight });

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      for (const e of entries) {
        const { width, height } = e.contentRect;
        setSize((prev) => {
          const w = Math.max(minWidth, Math.round(width));
          const h = Math.max(minHeight, Math.round(height));
          if (prev.width === w && prev.height === h) return prev;
          return { width: w, height: h };
        });
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [minWidth, minHeight]);

  return [ref, size];
};
